import * as Sentry from '@sentry/react'

export function initSentry() {
  const dsn = import.meta.env['VITE_SENTRY_DSN']
  if (!dsn) return

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    initialScope: { tags: { app: 'dashboard' } },
  })
}
